export default "__VITE_ASSET__e7$pKj0g__"